<script setup lang="ts">
import { computed, toRefs } from "vue";
import { PLD_EMPTY_LABEL, PLD_SYNC_ERROR_DESCRIPTION } from "./theme";

const props = withDefaults(
  defineProps<{
    height?: number;
    description?: string;
  }>(),
  { height: 96, description: PLD_SYNC_ERROR_DESCRIPTION }
);

const { height, description } = toRefs(props);

const containerStyle = computed(() => ({ minHeight: `${height.value}px` }));

const ui = {
  container:
    "flex flex-col items-center justify-center gap-1 rounded-lg border border-dashed border-secondary-200 bg-secondary-50 px-3 text-center",
  title: "text-sm font-medium text-secondary-700",
  description: "text-xs text-secondary-700",
};
</script>

<template>
  <div :class="ui.container" :style="containerStyle">
    <span :class="ui.title">{{ PLD_EMPTY_LABEL }}</span>
    <span :class="ui.description">{{ description }}</span>
  </div>
</template>
